<template>
    <div class="console">
        <div class="hello">
            <div class="l">
                <img src="https://i.gtimg.cn/club/item/face/img/2/16022_100.gif" alt="">
            </div>
            <div class="r">
                <div class="t">您好{{name}}！欢迎登录意健险系统。</div>
                <div class="b">最近更新：1、新增安心模块。</div>
            </div>
        </div>

        <el-row>
            <el-col :lg="6" :md="12" :sm="12">
                <div class="echart">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            访问量
                        </div>
                        <el-tag type="success">
                            日
                        </el-tag>
                    </div>
                    <div class="content" ref="visit" id="visit"></div>
                    <div class="bottom">日均访问量: 32,801</div>
                </div>
            </el-col>

            <el-col :lg="6" :md="12" :sm="12">
                <div class="echart" style="margin-left:10px">
                    <div class="title">
                        <div class="l">
                            <i class="el-icon-data-line"></i>
                            授权量
                        </div>
                        <el-tag type="warning">
                            周
                        </el-tag>
                    </div>
                    <div class="content" ref="authorization" id="authorization"></div>
                    <div class="bottom">授权数: 7,496</div>
                </div>
            </el-col>
            <el-col :lg="12" :md="24" :sm="24">
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name: 'console',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            visitChart:null,
            authorizationChart:null,
            name:localStorage.getItem('name'),
            tableData:[{
                type:"车险公估",
                caseNumber:"237231",
                caseFinanceNumber:"215",
                projectNumber:"1643",
                projectFinanceNumber:"35",
            },{
                type:"意健险",
                caseNumber:"18787",
                caseFinanceNumber:"215",
                projectNumber:"261",
                projectFinanceNumber:"35",
            },{
                type:"资产评估",
                caseNumber:"173",
                caseFinanceNumber:"15",
                projectNumber:"6",
                projectFinanceNumber:"1",
            },{
                type:"快赔(江门)",
                caseNumber:"81846",
                caseFinanceNumber:"215",
                projectNumber:"20",
                projectFinanceNumber:"5",
            }]
        }
    },
    created(){
        
        this.initVisitChart();
        this.initAuthorizationChart();
    },
    mounted(){
        let _this = this;
        
        window.onresize = function(){
            _this.initVisitChart();
            _this.initAuthorizationChart();
        }
    },
    methods:{
        initVisitChart(){
            let option = {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                series: [{
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true,
                    areaStyle: {},
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 1, 0, 0,
                            [
                                {offset: 0, color: '#13ce66'},
                                {offset: 0.5, color: '#58e7d6'},
                                {offset: 1, color: '#4ac1fe'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                console.log(this.$refs.visit);
                console.log(this.$echarts);
                console.log(this.visitChart);
                this.visitChart = this.$echarts.init(this.$refs.visit);
                this.visitChart.clear();
                this.visitChart.setOption(option,true);
                this.visitChart.resize();
            })
        },
        initAuthorizationChart(){
            let option = {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    type: 'value'
                },
                grid: {
                    top:'15% ',
                    bottom:'15% ',
                    left: '20% '
                },
                series: [{
                    data: [120, 200, 150, 80, 70, 110, 130],
                    type: 'bar',
                    showBackground: true,
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#83bff6'},
                                {offset: 0.5, color: '#188df0'},
                                {offset: 1, color: '#188df0'}
                            ]
                        )
                    },
                }]
            };
            this.$nextTick(()=>{
                console.log(this.$refs.authorization);
                console.log(this.$echarts);
                console.log(this.authorizationChart);
                this.authorizationChart = this.$echarts.init(this.$refs.authorization);
                this.authorizationChart.clear();
                this.authorizationChart.setOption(option,true);
                this.authorizationChart.resize();
            })
            
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000000;'
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .console{
        padding: 10px;
        .hello{
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            color: #303133;
            display: flex;
            align-items: center;
            min-height: 105px;
            padding: 20px;
            transition: .3s;
            .l{
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            .r{
                .t{
                    margin-bottom: 12px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #3c4a54;
                }
                .b{
                    font-size: 14px;
                    color: #808695;
                }
            }
            
        }
        .hello:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
        .echart{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            // min-height: 268px;
            margin-top: 20px;
            position: relative;
            height: 315px;
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                border-bottom: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .r{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #e7faf0;
                    border-color: #d0f5e0;
                    color: #13ce66;
                }
                .z{
                    height: 24px;
                    padding: 0 8px;
                    line-height: 24px;
                    background-color: #fff8e6;
                    border-color: #fff1cc;
                    color: #ffba00;
                }
            }
            .content{
                height: 220px;
            }
            .bottom{
                width: 100%;
                position: absolute;
                height: 50px;
                bottom: 0;
                border-top: 1px solid #ebeef5;
                display: flex;
                align-items: center;
                font-size: 14px;
                padding-left: 20px;
            }
        }
        .echart:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }

        .table{
            // width: 300px;
            border-radius: 2.5px;
            border: 1px solid #ebeef5;
            background-color: #fff;
            overflow: hidden;
            color: #303133;
            transition: .3s;
            min-height: 268px;
            margin-top: 20px;
            /deep/.el-table th{
                padding: 7px 0;
            }
            .title{
                font-size: 14px;
                line-height: 14px;
                padding: 0 20px;
                height: 44px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #ebeef5;
            }
            .content{
                height: 240px;
                padding: 15px;
            }
        }
        .table:hover{
            box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
        }
    }
</style>
